import styles from "./PageHeader.module.css";

/**
 * The title of a page and the things you can do on it (#409).
 *
 * ── WHY THIS EXISTS RATHER THAN EIGHT COPIES ──
 *
 * Every list page in the app had hand-rolled the same flex row. Seven of
 * them had exactly one action and looked fine; the eighth grew a second
 * one and fell apart, because `space-between` across three children
 * spreads them edge to edge instead of keeping the actions together:
 *
 *     "it would be better if those buttons were together on the right
 *      side and maybe swapped. Currently the 'Add Equipment' button is
 *      almost centered and the 'Merge' button is right aligned."
 *
 * Fixing the one page would have left the trap set for the next page
 * that gains a second button -- and TeamTasksPage had already fallen
 * into it once and been fixed by hand, which is the copy the eighth page
 * should have inherited and did not.
 *
 * ── ORDER IS THE CALLER'S, AND THE PRIMARY GOES LAST ──
 *
 * Children render left to right, so the everyday action belongs at the
 * END. It is the rightmost thing on the row, nearest the scrollbar and
 * the mouse, and it is the one people are here to press; the occasional
 * ones (merge these duplicates, manage the templates) sit to its left as
 * secondaries. That is the order TeamTasksPage already arrived at
 * independently -- Templates, Handoff, then Assign Task.
 *
 * ── IT TAKES A `title` STRING RATHER THAN CHILDREN ──
 *
 * So that every page's heading is a real <h1> at the same level. A
 * component that let callers pass any node would eventually be handed an
 * <h2>, or two headings, and the page outline that screen readers build
 * from them would stop matching what is on screen.
 */
export function PageHeader({ title, children }) {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {/* Always rendered, even when every action is hidden behind a
          feature gate. `{enabled && <Button/>}` yields false, not
          nothing, so testing for "has children" here would be testing
          the wrong thing -- and an empty group takes no space anyway. */}
      <div className={styles.actions}>{children}</div>
    </div>
  );
}
